<template>
  <div id="index" ref="appRef" class="screen-wrapper">
    <div class="screen-container">
      <div class="screen-header">
        <div class="header-time">
          <img :src="require('@/assets/screen/time-icon.png')" class="time-icon" />
          <span class="time-text">{{ currentTime }}</span>
        </div>
        <img :src="require('@/assets/screen/screen-logo.png')" class="screen-logo" />
        <div class="header-title">杜一生数据统计</div>
      </div>
      <div class="screen-content">
        <div class="screen-col col-left flex-col">
          <!-- 收款统计 -->
          <div class="screen-item">
            <screen-module-head :title-icon="require('@/assets/screen/userdata.png')" title-text="收款统计"
              :tabs="revenueData.periods" :description="revenueData.description" v-model="revenueData.period"
              @change="onRevenueTabChange" />
            <div class="statistics-cont flex-col">
              <div class="info-row flex">
                <div class="info-item flex-row col-3">
                  <div class="info-label">总金额</div>
                  <div class="info-value flex col-bottom">
                    <span class="value-total">{{ revenueData.total }}</span>
                    <div class="flex rate-box">
                      <span class="rate-text">10%</span>
                      <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="info-row flex">
                <div class="info-item flex-row col-3">
                  <div class="info-label">今日总收款</div>
                  <div class="info-value flex col-bottom">
                    <span class="value-total">{{ revenueData.today }}</span>
                    <div class="flex rate-box">
                      <span class="rate-text">10%</span>
                      <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                    </div>
                  </div>
                </div>
                <div class="info-item flex-row col-3">
                  <div class="info-label">本周收款</div>
                  <div class="info-value flex col-bottom">
                    <span class="value-total">{{ revenueData.week }}</span>
                    <div class="flex rate-box">
                      <span class="rate-text">10%</span>
                      <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                    </div>
                  </div>
                </div>
                <div class="info-item flex-row col-3">
                  <div class="info-label">本月收款</div>
                  <div class="info-value flex col-bottom">
                    <span class="value-total">{{ revenueData.month }}</span>
                    <div class="flex rate-box">
                      <span class="rate-text">10%</span>
                      <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="rate-info">
                <div class="rate-info-item">月目标完成率：90%</div>
                <div class="rate-info-item">年目标完成率：30%</div>
              </div>
            </div>
            <screen-line-chart :axis-data="revenueData.axisData" :series-data="revenueData.seriesData"
              :line-height="196" />
          </div>
          <div class="flex gap-10 col-normal">
            <!-- 客户类型 -->
            <div class="screen-item flex-1">
              <screen-module-head :title-icon="require('@/assets/screen/people.png')" title-text="客户类型"
                description="客户类型按季度算" />
              <div class="customer-type-cont">
                <div class="customer-type-item">
                  <div class="customer-type-item-title">A类客户</div>
                  <div class="customer-type-item-value">333</div>
                  <div class="rate-text">增长30人</div>
                </div>
                <div class="customer-type-item">
                  <div class="customer-type-item-title">B类客户</div>
                  <div class="customer-type-item-value">333</div>
                  <div class="rate-text">增长30人</div>
                </div>
                <div class="customer-type-item">
                  <div class="customer-type-item-title">C类客户</div>
                  <div class="customer-type-item-value">333</div>
                  <div class="rate-text">增长30人</div>
                </div>
                <div class="customer-type-item">
                  <div class="customer-type-item-title">D类客户</div>
                  <div class="customer-type-item-value">333</div>
                  <div class="rate-text minus-rate">减少200人</div>
                </div>
              </div>
            </div>
            <!-- 平台账户总余额 -->
            <div class="screen-item flex-1">
              <screen-module-head :title-icon="require('@/assets/screen/jing.png')" title-text="平台账户总余额"
                description="平台当前所有用户（包含大区，地区，县区）账户剩余额度总和" />
              <div class="statistics-cont flex-col">
                <div class="info-row flex">
                  <div class="info-item flex-row col-2">
                    <div class="info-label">余额账户</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ platformData.total }}</span>
                    </div>
                  </div>
                  <div class="info-item flex-row col-2">
                    <div class="info-label">零售价账户</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ platformData.xiaoduMoney }}</span>
                    </div>
                  </div>
                </div>
                <div class="info-row flex">
                  <div class="info-item flex-row col-2">
                    <div class="info-label">赠送账户</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ platformData.tuition }}</span>
                    </div>
                  </div>
                  <div class="info-item flex-row col-2">
                    <div class="info-label">积分账户</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ platformData.integral }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 收支明细 -->
          <div class="screen-item flex-1 account-details-container">
            <screen-module-head :title-icon="require('@/assets/screen/jing.png')" title-text="收支明细"
              :description="expenseData.description" :tabs="expenseData.periods" v-model="expenseData.period"
              @change="onExpenseTabChange" />
            <div class="flex account-details">
              <div class="account-type">
                <div class="account-type-title">账户支出</div>
                <div class="statistics-cont flex-col">
                  <div class="info-row flex">
                    <div class="info-item flex-row col-2">
                      <div class="info-label">余额账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                    <div class="info-item flex-row col-2">
                      <div class="info-label">零售价账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="info-row flex">
                    <div class="info-item flex-row col-2">
                      <div class="info-label">赠送账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                    <div class="info-item flex-row col-2">
                      <div class="info-label">积分账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="account-type">
                <div class="account-type-title">账户收入</div>
                <div class="statistics-cont flex-col">
                  <div class="info-row flex">
                    <div class="info-item flex-row col-2">
                      <div class="info-label">余额账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                    <div class="info-item flex-row col-2">
                      <div class="info-label">零售价账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="info-row flex">
                    <div class="info-item flex-row col-2">
                      <div class="info-label">赠送账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                    <div class="info-item flex-row col-2">
                      <div class="info-label">积分账户</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="screen-col flex-1 flex-col">
          <div class="flex flex-1 gap-16 col-top">
            <div class="flex-col flex-1 gap-16">
              <!-- 客户情况 -->
              <div class="screen-item">
                <screen-module-head :title-icon="require('@/assets/screen/userdata.png')" title-text="客户情况"
                  :tabs="customerInfo.periods" :description="customerInfo.description" v-model="customerInfo.period"
                  @change="onCustomerTabChange" />
                <div class="statistics-cont flex-col">
                  <div class="info-row flex">
                    <div class="info-item flex-row col-3">
                      <div class="info-label">加盟总人数</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.total }}</span>
                      </div>
                    </div>
                    <div class="info-item flex-row col-3">
                      <div class="info-label">本年加盟总人数</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ revenueData.total }}</span>
                        <div class="flex rate-box gap-0">
                          <span class="rate-text active">增长30人/</span>
                          <span class="rate-text">减少2人</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rate-info add-column">
                    <div class="rate-info-item">
                      <span>体验班</span>
                      <span>{{ customerData.experience }}</span>
                    </div>
                    <div class="rate-info-item">
                      <span>研修班</span>
                      <span>{{ customerData.training }}</span>
                    </div>
                    <div class="rate-info-item">
                      <span>子账号</span>
                      <span>{{ customerData.subAccount }}</span>
                    </div>
                  </div>
                </div>
                <screen-line-time-chart :series-data="customerInfo.seriesData" :line-height="112" />
              </div>
              <!-- 业务员 -->
              <div class="screen-item">
                <screen-module-head :title-icon="require('@/assets/screen/userdata.png')" title-text="业务员"
                  :tabs="salesData.periods" :description="salesData.description" v-model="salesData.period"
                  @change="onSalesTabChange" />
                <div class="statistics-cont flex-col">
                  <div class="info-row flex">
                    <div class="info-item flex-row col-3">
                      <div class="info-label">总人数</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ salesData.total }}</span>
                      </div>
                    </div>
                    <div class="info-item flex-row col-3">
                      <div class="info-label">本年新增总人数</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ salesData.total }}</span>
                        <div class="flex rate-box gap-0">
                          <span class="rate-text">增长30人</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rate-info add-column">
                    <div class="rate-info-item">
                      <span>大区经理</span>
                      <span>{{ customerData.experience }}</span>
                    </div>
                    <div class="rate-info-item">
                      <span>地区经理</span>
                      <span>{{ customerData.training }}</span>
                    </div>
                    <div class="rate-info-item">
                      <span>县区经理</span>
                      <span>{{ customerData.subAccount }}</span>
                    </div>
                  </div>
                </div>
                <screen-line-time-chart :series-data="salesData.seriesData" :line-height="112" />
              </div>
            </div>
            <div class="flex-col flex-1 gap-16">
              <!-- 出货统计 -->
              <div class="screen-item">
                <screen-module-head :title-icon="require('@/assets/screen/userdata.png')" title-text="出货统计"
                  :tabs="shipmentData.periods" :description="shipmentData.description" v-model="shipmentData.period"
                  @change="onRevenueTabChange" />
                <div class="statistics-cont flex-col">
                  <div class="info-row flex">
                    <div class="info-item flex-row col-3">
                      <div class="info-label">今年收款</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ shipmentData.total }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="info-row flex">
                    <div class="info-item flex-row col-3">
                      <div class="info-label">今日出货</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ shipmentData.today }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                    <div class="info-item flex-row col-3">
                      <div class="info-label">本周出货</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ shipmentData.week }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                    <div class="info-item flex-row col-3">
                      <div class="info-label">本月出货</div>
                      <div class="info-value flex col-bottom">
                        <span class="value-total">{{ shipmentData.month }}</span>
                        <div class="flex rate-box">
                          <span class="rate-text">10%</span>
                          <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rate-info">
                    <div class="rate-info-item">本月出货总量：90（30%）</div>
                    <div class="rate-info-item">本年出货总量：90（30%）</div>
                  </div>
                </div>
                <screen-line-chart :axis-data="shipmentData.axisData" :series-data="shipmentData.seriesData"
                  :line-height="196" />
              </div>
              <div class="flex gap-10 col-normal">
                <!-- 新老客户 -->
                <div class="screen-item new-old-customer">
                  <screen-module-head :title-icon="require('@/assets/screen/people.png')" title-text="新老客户"
                    :description="newOldData.description" />
                  <div class="customer-type-cont">
                    <div class="customer-type-item">
                      <div class="customer-type-item-title">App新客户(人)</div>
                      <div class="customer-type-item-value">598</div>
                    </div>
                    <div class="customer-type-item">
                      <div class="customer-type-item-title">C端新客户(人)</div>
                      <div class="customer-type-item-value">1598</div>
                    </div>
                    <div class="customer-type-item">
                      <div class="customer-type-item-title">App老客户(人)</div>
                      <div class="customer-type-item-value">333</div>
                    </div>
                    <div class="customer-type-item">
                      <div class="customer-type-item-title">C端老客户(人)</div>
                      <div class="customer-type-item-value">333</div>
                    </div>
                  </div>
                </div>
                <!-- 商品排名 -->
                <div class="screen-item product-ranking">
                  <screen-module-head :title-icon="require('@/assets/screen/jing.png')" title-text="商品排名"
                    :tabs="productRanking.periods" :description="productRanking.description"
                    v-model="productRanking.period" @change="onProductRankingTabChange" />
                  <div class="statistics-cont flex-col">
                    <div class="info-row flex">
                      <div class="info-item flex-row col-3">
                        <div class="info-label">总销量</div>
                        <div class="info-value flex col-bottom">
                          <span class="value-total">{{ productRanking.total }}</span>
                          <div class="flex rate-box">
                            <span class="rate-text">10%</span>
                            <img :src="require('@/assets/screen/icon-down.png')" class="arrow-icon" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rank-list">
                    <screen-rank-list title="产品名称" value-label="销量" value-key="sales" :list="productRanking.list"
                      :visible-count="2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex gap-10 col-normal">
            <!-- 线下会议统计 -->
            <div class="screen-item meeting-statistics">
              <screen-module-head :title-icon="require('@/assets/screen/jing.png')" title-text="线下会议统计"
                :description="meetingData.description" :tabs="meetingData.periods" v-model="meetingData.period"
                @change="onMeetingTabChange" />
              <div class="statistics-cont flex-col">
                <div class="info-row flex">
                  <div class="info-item flex-row col-3">
                    <div class="info-label">总会议(场)</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ meetingData.total }}</span>
                    </div>
                  </div>
                </div>
                <div class="info-row flex">
                  <div class="info-item flex-row col-3">
                    <div class="info-label">总报名(人)</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ meetingData.total }}</span>
                    </div>
                  </div>
                  <div class="info-item flex-row col-3">
                    <div class="info-label">总签到(人)</div>
                    <div class="info-value flex col-bottom">
                      <span class="value-total">{{ meetingData.total }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rank-list">
                <screen-rank-list name-label="会议类型" :columns="[
                  { key: 'sessions', label: '场次' },
                  { key: 'registered', label: '报名(人)' },
                  { key: 'signed', label: '签到(人)' }
                ]" :list="meetingData.list" :visible-count="3" name-key="type" layout="meeting" />
              </div>
            </div>
            <!-- 课程学习统计 -->
            <div class="screen-item course-learning-statistics">
              <screen-module-head :title-icon="require('@/assets/screen/jing.png')" title-text="课程学习统计"
                :description="courseLearningData.description" :tabs="courseLearningData.periods"
                v-model="courseLearningData.period" @change="onCourseLearningTabChange" />
              <div class="flex gap-10 col-normal">
                <div class="flex-1 flex-col row-between">
                  <div class="statistics-cont flex-col">
                    <div class="info-row flex">
                      <div class="info-item flex-row col-2">
                        <div class="info-label">总观看课程量</div>
                        <div class="info-value flex col-bottom">
                          <span class="value-total">{{ courseLearningData.totalViews }}</span>
                        </div>
                      </div>
                      <div class="info-item flex-row col-2">
                        <div class="info-label">总观看时长</div>
                        <div class="info-value flex col-bottom">
                          <span class="value-total">{{ courseLearningData.totalDuration }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rank-list">
                    <screen-rank-list title="客户观看排名" name-width-class="w-100" value-label="观看课程时长"
                      :list="courseLearningData.viewRanking" value-key="duration" :visible-count="4" />
                  </div>
                </div>
                <div class="flex-1 rank-list">
                  <screen-rank-list title="试卷考试排名" name-width-class="w-100" value-label="合格人数"
                    :list="courseLearningData.examRanking" value-key="count" :visible-count="7"
                    value-format="withRate" />
                </div>
                <div class="flex-1 rank-list">
                  <screen-rank-list title="课程观看人数排名" value-label="观看人数" :list="courseLearningData.courseRanking"
                    value-key="count" :visible-count="7" name-width-class="line-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '@/utils/drawMixin'
import ScreenModuleHead from './components/module-head.vue'
import ScreenLineChart from './components/lineChart.vue'
import ScreenLineTimeChart from './components/lineTimeChart.vue'
import ScreenRankList from './components/rankList.vue'
import DataBoardV2Api from '@/api/dataBoard/DataBoardV2'

export default {
  name: 'Screen1',
  mixins: [drawMixin],
  components: {
    ScreenModuleHead,
    ScreenLineChart,
    ScreenLineTimeChart,
    ScreenRankList
  },
  data() {
    return {
      currentTime: '',
      timeTimer: null,
      revenueData: {
        total: '7890',
        today: '7890',
        week: '7890',
        month: '7890',
        period: 1,
        description: '统计平台所有现金收入（包含线下支付的）。',
        periods: [{ label: '本周', value: 1 }, { label: '本月', value: 2 }, { label: '本年', value: 3 }],
        axisData: ['周一', '周二', '周三', '周四', '周五', '周六', '周天'],
        seriesData: [
          { name: '当前', color: '#1596CD', showArea: true, data: [28, 18, 40, 60, 88, 40, 20] },
          { name: '环比', color: '#EFDB1C', showArea: true, data: [30, 25, 15, 70, 35, 45, 50] },
          { name: '同比', color: '#33AD47', showArea: true, data: [60, 35, 45, 90, 65, 75, 80] }
        ]
      },
      customerData: {
        total: '7890',
        yearTotal: '7890',
        experience: '333',
        training: '333',
        subAccount: '333'
      },
      platformData: {
        total: '7890',
        xiaoduMoney: '7890',
        tuition: '333',
        integral: '333'
      },
      shipmentData: {
        total: '7890',
        today: '7890',
        week: '7890',
        month: '7890',
        period: 1,
        description: '1、曲线图统计按时间筛选显示所有出货订单款；<br>2、核算方式：统一按照实际的出货价格统计：统一按照零售价的5折来算出货数据，如果低于5折按照实际折扣计算；',
        periods: [{ label: '本周', value: 1 }, { label: '本月', value: 2 }, { label: '本年', value: 3 }],
        axisData: ['周一', '周二', '周三', '周四', '周五', '周六', '周天'],
        seriesData: [
          { name: '当前', color: '#1596CD', showArea: true, data: [28, 18, 40, 60, 88, 40, 20] },
          { name: '环比', color: '#4DE1E9', showArea: true, data: [30, 25, 15, 70, 35, 45, 50] },
          { name: '同比', color: '#891ACD', showArea: true, data: [60, 35, 45, 90, 65, 75, 80] }
        ]
      },
      customerInfo: {
        total: '7890',
        yearTotal: '7890',
        period: 2,
        periods: [{ label: '今日', value: 0 }, { label: '本周', value: 1 }, { label: '本月', value: 2 }, { label: '本年', value: 3 }],
        description: '1、本年加盟总人数，体验班，研修班，子账号，曲线图都按时间筛选统计新增人数；<br>2、加盟总人数：显示平台所有加盟总数，体验班，研修班（不包含子账号）统计；统计出这个时间内所有客户的情况',
        seriesData: [
          { name: '当前', color: '#1596CD', data: [['2024/01/11', 50], ['2024/01/12', 62], ['2024/01/13', 75], ['2024/01/14', 82], ['2024/01/15', 88], ['2024/01/16', 92], ['2024/01/17', 98]] },
          { name: '环比', color: '#9292C1', data: [['2024/01/11', 40], ['2024/01/12', 55], ['2024/01/13', 65], ['2024/01/14', 72], ['2024/01/15', 78], ['2024/01/16', 85], ['2024/01/17', 90]] },
          { name: '同比', color: '#EFDB1C', data: [['2024/01/11', 58], ['2024/01/12', 70], ['2024/01/13', 80], ['2024/01/14', 88], ['2024/01/15', 94], ['2024/01/16', 100], ['2024/01/17', 105]] }
        ]
      },
      salesData: {
        total: '7890',
        newTotal: '7890',
        regional: '333',
        area: '333',
        county: '333',
        period: 2,
        periods: [{ label: '本月', value: 2 }, { label: '本年', value: 3 }],
        description: '1、本年新增总人数，大区经理，地区经理，县区经理，曲线图都按时间筛选统计新增人数；<br>2、总人数：显示平台所有大区，地区，县区人数统计；（审核通过有了身份权限才统计）',
        seriesData: [
          { name: '当前', color: '#E323FF', data: [['2024/01/11', 50], ['2024/01/12', 62], ['2024/01/13', 75], ['2024/01/14', 82], ['2024/01/15', 88], ['2024/01/16', 92], ['2024/01/17', 98]] },
          { name: '环比', color: '#5A5A89', data: [['2024/01/11', 40], ['2024/01/12', 55], ['2024/01/13', 65], ['2024/01/14', 72], ['2024/01/15', 78], ['2024/01/16', 85], ['2024/01/17', 90]] },
          { name: '同比', color: '#1596CD', data: [['2024/01/11', 58], ['2024/01/12', 70], ['2024/01/13', 80], ['2024/01/14', 88], ['2024/01/15', 94], ['2024/01/16', 100], ['2024/01/17', 105]] }
        ]
      },
      newOldData: {
        appNew: '598',
        appOld: '1598',
        cNew: '598',
        cOld: '1598',
        description: '新客户，老客户【第一次加盟时间1年内；  eg：普通人升为体验班，再体验班升为研修班，还是按升为体验班时间1年内。】'
      },
      productRanking: {
        total: '7890',
        period: 1,
        periods: [{ label: '今日', value: 0 }, { label: '本周', value: 1 }, { label: '本月', value: 2 }, { label: '本年', value: 3 }],
        description: '根据实际筛选显示对应时间内的所有产品销量和总销量',
        list: [
          { name: '祛痘产品祛痘产品祛痘产品祛痘产品祛痘产品祛痘产品祛痘产品', sales: '3333' },
          { name: '祛痘产品', sales: '3333' }
        ]
      },
      expenseData: {
        period: 2,
        periods: [{ label: '今日', value: 0 }, { label: '本周', value: 1 }, { label: '本月', value: 2 }, { label: '本年', value: 3 }],
        description: '账户支出：按时间筛选 统计出这个时间内所有用户（包含大区，地区，县区）支出的总和；<br> 账户收入：按时间筛选 统计出这个时间内所有用户（包含大区，地区，县区）收入的总和'
      },
      meetingData: {
        total: '7890',
        registered: '598',
        signed: '598',
        period: 1,
        periods: [{ label: '本周', value: 1 }, { label: '本月', value: 2 }, { label: '本年', value: 3 }],
        description: '总会议，总报名人，总签到人，会议类型排名都按时间筛选显示对应数据',
        list: [
          { type: '地区培训', sessions: '10', registered: '99999', signed: '180' },
          { type: '专题课', sessions: '5', registered: '150', signed: '140' },
          { type: '月度复盘会', sessions: '3', registered: '100', signed: '95' },
          { type: '地区培训', sessions: '10', registered: '99999', signed: '180' },
          { type: '专题课', sessions: '5', registered: '150', signed: '140' },
          { type: '月度复盘会', sessions: '3', registered: '100', signed: '95' },
          { type: '地区培训', sessions: '10', registered: '99999', signed: '180' },
          { type: '专题课', sessions: '5', registered: '150', signed: '140' },
          { type: '月度复盘会', sessions: '3', registered: '100', signed: '95' }
        ]
      },
      courseLearningData: {
        totalViews: '0',
        totalDuration: '0',
        period: 2,
        periods: [{ label: '本月', value: 2 }, { label: '本年', value: 3 }],
        description: '1、客户观看排名，试卷考试排名，课程观看人数排名都安装时间筛选统计； <br> 2、试卷考试算法：按人算 ，同一个试卷同一个人多次考也只算一个人（考5次也算一个人，只要有一次合格  他就算合格了）；<br>3、课程观看人数算法：同一个人观看同一个课程那怕多次只算一个人；',
        viewRanking: [],
        examRanking: [],
        courseRanking: []
      }
    }
  },
  mounted() {
    this.updateTime()
    this.timeTimer = setInterval(this.updateTime, 60000)
  },
  beforeDestroy() {
    if (this.timeTimer) clearInterval(this.timeTimer)
  },
  created() {
    this.getCourseLearningData()
  },
  methods: {
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      this.currentTime = `${year}-${month}-${day} ${hour}:${minute}`
    },
    onExpenseTabChange(index) {
      this.expenseData.period = index
    },
    onCustomerTabChange(index) {
      this.customerInfo.period = index
    },
    onRevenueTabChange() { },
    onProductRankingTabChange(index) {
      this.productRanking.period = index
    },
    onSalesTabChange(index) {
      this.salesData.period = index
    },
    onMeetingTabChange(index) {
      this.meetingData.period = index
    },
    onCourseLearningTabChange(index) {
      this.courseLearningData.period = index;
      this.courseLearningData.totalViews = 0;
      this.courseLearningData.totalDuration = 0;
      this.getCourseLearningData()
    },
    getCourseLearningData() {
      const period = this.courseLearningData.period;
      const now = new Date();
      let startTime = '';
      let endTime = '';

      if (period === 2) {
        const year = now.getFullYear();
        const month = now.getMonth() + 1; // 转为实际月份（1-12）
        // 当月第一天
        startTime = `${year}-${month.toString().padStart(2, '0')}-01 00:00:00`;

        // 计算当月最后一天
        // 技巧：new Date(year, month, 0) 返回当月最后一天（month 是实际月份）
        const lastDay = new Date(year, month, 0).getDate();
        endTime = `${year}-${month.toString().padStart(2, '0')}-${lastDay} 23:59:59`;
      } else if (period === 3) {
        const year = now.getFullYear();
        startTime = `${year}-01-01 00:00:00`;
        endTime = `${year}-12-31 23:59:59`;
      }
      DataBoardV2Api.learningAnalysisCourse({ startTime, endTime }).then(res => {
        const { count, duration, listByUser, listByTestPaper, listByCourse } = res.data;
        this.courseLearningData.totalViews = count;
        this.courseLearningData.totalDuration = duration;
        this.courseLearningData.viewRanking = listByUser;
        this.courseLearningData.examRanking = listByTestPaper;
        this.courseLearningData.courseRanking = listByCourse;
      }).catch(err => {
        this.$message.error(err.message);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-wrapper {
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: left top;
  overflow: hidden;
  background: #05050F;
}

.screen-container {
  width: 100%;
  height: 100%;
  background: #05050F;
  color: #ffffff;
  box-sizing: border-box;
  overflow: hidden;

  .gap-0 {
    gap: 0 !important;
  }

  .gap-10 {
    gap: 10px;
  }

  .gap-16 {
    gap: 16px;
  }

  .col-2 {
    width: calc(100% / 2);
  }

  .col-3 {
    width: calc(100% / 3);
  }

  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
    display: flex;
  }

  .flex-1 {
    flex: 1;
  }

  .row-between {
    justify-content: space-between;
  }
}

.screen-header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  gap: 8px;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
  background-color: #14142B;

  .screen-logo {
    width: 40px;
    height: 40px;
  }

  .header-title {
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
  }

  .header-time {
    position: absolute;
    top: 20px;
    left: 20px;
    font-size: 24px;
    display: flex;
    align-items: center;
    gap: 10px;

    .time-icon {
      width: 24px;
      height: 24px;
    }

    .time-text {
      font-size: 24px;
      line-height: 24px;
      color: #9292C1;
    }
  }
}

.screen-content {
  display: flex;
  gap: 16px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  align-items: normal;

  .screen-col {
    gap: 16px;
    display: flex;
    flex-direction: column;
  }

  .col-left {
    width: 616px;
  }

  .col-top {
    display: flex;
    gap: 16px;
  }

  .col-normal {
    display: flex;
    gap: 10px;
  }
}

.screen-item {
  width: 100%;
  padding: 16px 15px;
  border-radius: 8px;
  box-sizing: border-box;
  background: #14142B;

  .statistics-cont {
    gap: 20px;
    position: relative;
    display: flex;
    flex-direction: column;

    .info-row {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .info-item {
        display: flex;
        gap: 6px;
        flex-direction: column;

        &.col-2 {
          width: calc(50% - 5px);
        }

        &.col-3 {
          width: calc(33.33% - 7px);
        }

        .info-label {
          font-size: 16px;
          line-height: 17px;
          color: #FFFFFF;
        }

        .info-value {
          display: flex;
          gap: 4px;
          align-items: flex-end;

          .value-total {
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
          }

          .rate-box {
            display: flex;
            gap: 6px;
            padding-bottom: 4px;
            align-items: center;

            .rate-text {
              font-size: 12px;
              color: #5EFF5A;

              &.active {
                color: #E73F3F;
              }
            }

            .arrow-icon {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }

    .rate-info {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;

      &.add-column {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .rate-info-item {
          display: flex;
          width: 120px;
          align-items: center;
          justify-content: space-between;
        }
      }

      .rate-info-item {
        color: #FFFFFF;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }

  .customer-type-cont {
    gap: 12px;
    display: flex;
    flex-wrap: wrap;

    .customer-type-item {
      color: #ffffff;
      width: calc((100% - 12px) / 2);

      .customer-type-item-title {
        font-size: 14px;
        line-height: 17px;
      }

      .customer-type-item-value {
        font-size: 24px;
        font-weight: bold;
        line-height: 29px;
      }

      .rate-text {
        font-size: 12px;
        color: #E73F3F;
        line-height: 13px;
        padding-top: 2px;

        &.minus-rate {
          color: #5EFF5A;
        }
      }
    }
  }

  .account-details {
    gap: 11px;
    display: flex;

    .account-type {
      flex: 1;
      padding: 10px 15px 20px;
      border-radius: 8px;
      background-color: #2B2B40;

      .account-type-title {
        font-size: 16px;
        color: #FFFFFF;
        padding-bottom: 20px;
      }
    }
  }

  .rank-list {
    gap: 10px;
    padding-top: 20px;
    line-height: 16px;
    display: flex;
    flex-direction: column;

    .rank-item-header {
      font-size: 14px;
      display: flex;
    }

    .rank-item {
      line-height: 14px;
      font-size: 14px;
      gap: 10px;
      display: flex;

      .rank-item-name {
        padding: 1px 2px;
        border-radius: 2px;
        display: inline-block;
        box-sizing: border-box;
        background: linear-gradient(to right, #E323FF, #7517F8);

        &.w-100 {
          width: 100px;
        }

        &.line-1 {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .rank-item-value {
        flex-shrink: 0;
      }
    }
  }
}

.account-details-container {
  ::v-deep .screen-module-head {
    padding-bottom: 30px;
  }
}

.new-old-customer .customer-type-cont {
  gap: 23px;

  .customer-type-item {
    width: calc((100% - 23px) / 2);

    .customer-type-item-title {
      font-size: 16px;
    }

    .customer-type-item-value {
      font-size: 24px;
      font-weight: bold;
      line-height: 30px;
      padding-top: 3px;
    }
  }
}

.product-ranking {
  width: 340px;
  flex-shrink: 0;

  ::v-deep .screen-module-head {
    padding-bottom: 16px;
  }
}

.meeting-statistics {
  width: 325px;
  flex-shrink: 0;

  ::v-deep .screen-module-head {
    padding-bottom: 16px;
  }

  .rank-list {
    .rank-item-header {
      justify-content: flex-end;

      .rank-item-name {
        margin-right: auto;
        flex: 2;
      }

      .rank-item-value {
        flex: 1;
        text-align: right;
      }
    }

    .rank-item {
      justify-content: flex-end;

      .rank-item-name,
      .mr-auto {
        flex: 2;
        margin-right: auto;
      }

      .rank-item-value {
        flex: 1;
        text-align: right;
      }
    }
  }
}

.course-learning-statistics {
  ::v-deep .screen-module-head {
    padding-bottom: 10px;
  }

  .statistics-cont {
    padding-top: 10px;
  }

  .rank-list {
    padding: 10px 15px;
    background: #2B2B40;
    border-radius: 8px;
    box-sizing: border-box;
  }
}
</style>
